import i18n from "../i18n";
import messages from "./publicTextData.json";

const language = () => (i18n.resolvedLanguage || i18n.language || "ja").toLowerCase().startsWith("en") ? "en" : "ja";
const englishFragments = Object.entries(messages).filter(([key, value]) => /[\u3040-\u30ff\u4e00-\u9fff]/.test(key) && typeof value.en === "string").sort((a, b) => b[0].length - a[0].length);
const renderedCache = new Map();
const normalize = value => value.replace(/\s+/g, " ").trim();

// Translate rendered strings only. Dataset keys, values, calculations and links stay intact.
export function publicText(value) {
  if (Array.isArray(value)) return value.map(publicText);
  if (typeof value !== "string") return value;
  const message = messages[normalize(value)];
  if (!message) {
    if (language() !== "en" || !/[\u3040-\u30ff\u4e00-\u9fff]/.test(value)) return value;
    if (renderedCache.has(value)) return renderedCache.get(value);
    let translated = value.replace(/(\d{1,2}:\d{2})頃/g, "around $1");
    for (const [source, target] of englishFragments) translated = translated.split(source).join(target.en);
    if (renderedCache.size > 5000) renderedCache.clear();
    renderedCache.set(value, translated);
    return translated;
  }
  if (Array.isArray(message[language()])) return value;
  const translated = message[language()];
  if (translated == null) return value;
  return (value.match(/^\s*/)?.[0] || "") + translated.trim() + (value.match(/\s*$/)?.[0] || "");
}

export function publicTemplate(id, values) {
  const parts = messages[`template_${id}`]?.[language()];
  if (!parts) return "";
  return parts.reduce((text, part, index) => text + part + (index < values.length ? String(publicText(values[index])) : ""), "");
}
